(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodPopover', sodPopover);

    function sodPopover($document, lodash) {
        return {
            restrict: 'E',
            controller: sodPopoverCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/components/sod-popover',
            scope: {
                label: '=',
                options: '=?',
                togglePopover: '=',
                onPopoverClose: '&?',
                onPopoverOpen: '&?'
            },
            link: sodPopoverLink
        };

        function sodPopoverLink(scope, elem, attr) {
            var vm = scope.vm,
                //dropdown = elem.find('.dropdown'),
                popOverActionElem = elem.find('.sod-popover-action');

            popOverActionElem.on('click', sodPopoverActionClick);
            $document.on('mousedown', onDocumentClick);

            elem.find('.sod-popover').addClass(attr.class);

            scope.$on('$destroy', function () {
                popOverActionElem.off('click', sodPopoverActionClick);
                $document.off('mousedown', onDocumentClick);
            });

            function sodPopoverActionClick(e) {
                // console.log('sodPopoverActionClick *************************');
                if (lodash.get(vm, 'options.can_toggle', true) === true) {
                    e.preventDefault();
                    vm.toggle();
                    scope.$apply();
                }
            }

            function onDocumentClick(e) {
                const toggleOptions = lodash.get(vm, 'options', 'toggleable', true);
                if (!toggleOptions) { return; }

                var parents = angular.element(e.target).parents('#' + attr.id + ', .item.active[data-value], .k-calendar-container, .datepicker.datepicker-dropdown');
                if (parents.length == 0) {
                    if (vm.toggleState) {
                        vm.toggle();
                        scope.$apply();
                    }
                }
            }
        }
    }

    function sodPopoverCtrl() {
        var vm = this;

        this.$onInit = function() {
            vm.toggleState = false;

            vm.toggle = toggle;
            vm.togglePopover = () => {
                // console.log('===================================================================================');
                toggle();
            };
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;

            if (!vm.toggleState) {
                if (typeof vm.onPopoverClose === typeof function () {
                    }) {
                    vm.onPopoverClose();
                }
            } else {
                if (typeof vm.onPopoverOpen === typeof function () {
                    }) {
                    vm.onPopoverOpen();
                }
            }
        }
    }
})();